import pptxgen from 'pptxgenjs'

import { percentageToInches, getCoordinates, SLIDE_SIZE_PX, decodeHtml } from '../helpers'
import { COLORS, OPEN_SANS_REGULAR } from '../common/constants'

import { LABEL_MAP } from '_components/audience-insights/template/layouts/Multiline'

function toMSDate(JSDate) {
  const returnDateTime =
    25569.0 + // Offset date to match MS format https://stackoverflow.com/a/61106439/11166939
    (JSDate.getTime() - JSDate.getTimezoneOffset() * 60 * 1000) / (1000 * 60 * 60 * 24)
  return returnDateTime
}

const pptx = new pptxgen()

function renderMultilineChart({ x, y, height, width, parent, svgNode, slide }) {
  const coordinates = getCoordinates({ x, y }, parent)

  const xOffset = (width / 100) * 2
  const yOffset = (height / 100) * 2
  const translateX = percentageToInches(xOffset / 1920, 'x')
  const translateY = percentageToInches(yOffset / 1080, 'y')

  const chartPosition = {
    x: coordinates.x + translateX,
    y: coordinates.y + (height > 300 && translateY),
    h: percentageToInches((height - yOffset) / SLIDE_SIZE_PX.y, 'y'),
    w: percentageToInches((width - xOffset) / SLIDE_SIZE_PX.x, 'x'),
  }

  // Get data
  const data = svgNode.properties['data-json']
  const yLabel = svgNode.properties['data-y-label']

  const decodedData = JSON.parse(decodeHtml(data))
  const chartData = Object.keys(decodedData[0].values).map((key) => ({
    name: key,
    labels: decodedData.map(({ date }) => toMSDate(new Date(date))),
    values: decodedData.map(({ values }) => values[key]),
  }))

  slide.addChart(pptx.ChartType.line, chartData, {
    ...chartPosition,
    // X axis
    catAxisBaseTimeUnit: 'days',
    catAxisLabelColor: '9b9b9b',
    catAxisLabelFontFace: OPEN_SANS_REGULAR,
    catAxisLabelFontSize: 8,
    catAxisLabelPos: 'low',
    catAxisMajorTimeUnit: 'months',
    catLabelFormatCode: 'mmm',
    displayBlanksAs: 'gap',
    // Y axis
    valAxisLabelFormatCode: '[>999] #0, "K"', // https://www.excel-easy.com/examples/custom-number-format.html
    valAxisLabelColor: '9b9b9b',
    valAxisLabelFontFace: OPEN_SANS_REGULAR,
    valAxisLabelFontSize: 8,
    showValAxisTitle: !!yLabel,
    valAxisTitle: yLabel ?? '',
    valAxisTitleColor: '#666666',
    valAxisTitleFontSize: 7,
    valGridLine: { style: 'none' },
    // Legend
    showLegend: true,
    legendPos: 't',
    // Misc
    chartColors: COLORS,
    colors: COLORS,
    lineDataSymbol: 'none',
    lineDataSymbolSize: null,
    lineSmooth: true,
  })
}

export default renderMultilineChart
